import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Seo } from "@/components/Seo";
import { DemoBanner } from "@/components/portal/DemoBanner";
import { listLoads, type LoadRecord } from "@/features/loads/repo";
import { useAuth } from "@/features/auth/useAuth";

export default function CustomerDashboard() {
  const { user } = useAuth();
  const [loads, setLoads] = useState<LoadRecord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listLoads(user)
      .then(setLoads)
      .catch(() => setLoads([]))
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <>
      <Seo title="Customer portal" noindex />
      <DemoBanner />
      <h1 className="text-2xl font-bold">Your shipments</h1>
      <p className="mt-1 text-sm text-brand-500">
        Read-only view of your shipments and documents.
      </p>

      {loading && <p className="mt-6 text-sm text-brand-500">Loading shipments...</p>}

      {!loading && loads.length === 0 && (
        <p className="mt-6 text-sm text-brand-500">No shipments found for your account.</p>
      )}

      <div className="mt-6 grid gap-4">
        {loads.map((load) => (
          <Card key={load.id}>
            <CardHeader>
              <div className="flex flex-wrap items-center justify-between gap-3">
                <CardTitle className="break-words">#{load.reference}</CardTitle>
                <Badge variant="accent">{load.status.replace(/_/g, " ")}</Badge>
              </div>
            </CardHeader>
            <CardContent>
              <p className="break-words text-sm text-brand-600">
                {load.origin} &rarr; {load.destination}
              </p>
              <p className="mt-1 text-sm text-brand-500">
                Pickup {load.pickup} - Delivery {load.delivery}
              </p>
              <Link
                to={`/track?ref=${encodeURIComponent(load.reference)}`}
                className="mt-3 inline-block text-sm font-medium text-brand-600 hover:underline"
              >
                Track this shipment
              </Link>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
}
